import { render, staticRenderFns } from "./PDFPageV2.vue?vue&type=template&id=dd05c822&scoped=true&"
import script from "./PDFPageV2.vue?vue&type=script&lang=js&"
export * from "./PDFPageV2.vue?vue&type=script&lang=js&"
import style0 from "./PDFPageV2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PDFPageV2.vue?vue&type=style&index=1&lang=css&"
import style2 from "./PDFPageV2.vue?vue&type=style&index=2&id=dd05c822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd05c822",
  null
  
)

export default component.exports